/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { CourseUnitInfoValues } from './courseUnitInfoModal.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'course-unit-info-modal',
    standalone: false,
})
export class CourseUnitInfoModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Input() resolve: CourseUnitInfoValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('courseUnitInfoModal', elementRef, injector);
    }
}
